import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const BRAND = {
  mascot:
    "https://customer-assets.emergentagent.com/job_3f08d268-9146-4d19-9fd5-ee1171693f6e/artifacts/2lv3oe0n_IMG_4064.jpeg",
  idCardTemplate:
    "https://customer-assets.emergentagent.com/job_3f08d268-9146-4d19-9fd5-ee1171693f6e/artifacts/p7q2ofgf_DCE67844-C567-4AA7-AEA9-35DAE3FF830B.png",
};

export const CATEGORY_IMAGES = {
  "sensory-tools": "https://images.pexels.com/photos/8617568/pexels-photo-8617568.jpeg",
  "safety-products": "https://images.unsplash.com/photo-1606229365485-93a3b8ee0385?w=600",
  "autism-clothing": "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=600",
  "bedding": "https://images.unsplash.com/photo-1688383454437-c3c6805a8ec0?w=600",
  "aac-speech": "https://images.unsplash.com/photo-1654414884104-c6fc9a27ed35?w=600",
  "communication": "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600",
  "educational-books": "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=600",
  "games": "https://images.unsplash.com/photo-1606092195730-5d7b9af1efc5?w=600",
  "food-therapy": "https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=600",
  "eating-therapy": "https://images.unsplash.com/photo-1547592180-85f173990554?w=600",
  "natural-relief": "https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=600",
  "mobility": "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=600",
  "sports-gear": "https://images.unsplash.com/photo-1517649763962-0c623066013b?w=600",
};

export const formatMoney = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(v || 0);
